<template>
  <Box class="box-wrapper">
    <template v-slot:header>
      <div>{{ $t('common.exchangeAndSurplus') }}</div>
    </template>
    <template v-slot:body>
      <div class="reedem-and-remainging-table-content">
        <div class="item">
          <span class="item-left">{{ $t('common.remainingLot') }}</span>
          <span class="item-right">{{ remainingLots.toFixed(3) }} {{ $t('common.hand') }}</span>
        </div>
        <div class="divide-line"></div>
        <div class="item">
          <span class="item-left">{{ $t('common.redeemedLot') }}</span>
          <span class="item-right">{{ lotsConverted.toFixed(2) }} {{ $t('common.hand') }}</span>
        </div>
        <div class="divide-line"></div>
        <div class="item">
          <span class="item-left">{{ $t('common.amountWithdrawn') }}</span>
          <span class="item-right">$ {{ creditConverted.toFixed(2) }}</span>
        </div>
      </div>
    </template>
  </Box>
</template>

<script>
import Box from '@/components/widgets/Box.vue';

export default {
  name: 'RedeemAndRemainingTable',
  components: {
    Box
  },
  props: {
    remainingLots: {
      type: Number,
      default: 0
    },
    lotsConverted: {
      type: Number,
      default: 0
    },
    creditConverted: {
      type: Number,
      default: 0
    }
  }
};
</script>

<style lang="scss" scoped>
.reedem-and-remainging-table-content {
  padding: 0px 49px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;

  & > .item {
    line-height: 1;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  & > .item:not(:first-child) {
    margin-top: 36px;
  }

  & .item-left {
    color: #000d28;
    font-size: 21px;
    font-family: NotoSansCJKsc-Medium;
  }

  & .item-right {
    color: $HIGHLIGHT_COLOR;
    font-size: 32px;
    font-family: NotoSansCJKsc-Medium;
  }

  @media (max-width: $DEVICE_SIZE_MOBILEL) {
    padding: 10px 0px;
  }
}
.divide-line {
  height: 1px;
  width: 100%;
  border-bottom: solid 1px rgba(151, 151, 151, 0.58);
  margin: 0 auto;
  margin-top: 32px;
}
</style>
